<template>

  <div id="home" class="cont">

    <header class="main-header">
        <h1><span class="h1-a">Pensamientos</span> latinoamericanos</h1>
        <p class="main-bajada">Textos y antolog&iacute;as</p>
    </header>

    <!-- Loading -->
    <div class="loading" v-if="loading">
      <div class="loader"></div>
    </div>


    <div v-if="error" class="error">
      {{ error }}
    </div>

    <transition name="fade" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" mode="out-in">

      <main v-if="autores" class="main-content">

        <div :class="autorClases(autor.tipo)" v-for="autor in autores">

          <router-link :to="{ name: 'autor', params: { id: autor.id }}">

            <div :style="autorImg(autor.img)" class="autor-img"></div>

            <h2 class="nombre-autor-home">{{ autor.nombre }} <span class="accent">{{ autor.apellido }}</span></h2>

          </router-link>
        </div>

      </main>

    </transition>


  </div>


</template>

<script>


export default {
  name: 'Home',

  data () {
    return {
      loading: false,
      error: null,
      autores: false // false
    }
  },

  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },

  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },

  methods: {
    fetchData () {
      this.error = this.autores = null;
      this.loading = true;

      // vue resource
        this.$http.get('/api/autores.php').then(function (response) {
        // this.$http.get('http://temp1.unla.edu.ar/penslat-build/api/autores.php').then(function (response) {

        this.loading = false;

        this.autores = response.data;

      }, function (response) {

        console.log("Error: No se recibieron los autores");

      });

      /* TEST DATA
      --------------------------------------*/
      // this.loading = false;
      // this.autores = [{id: "1",nombre: "Manuel",apellido: "Ugarte",tipo: "1",img: "ugarte.png",orden: "1"},{id: "9",nombre: "Víctor Raúl",apellido: "Haya De La Torre",tipo: "1",img: "haya-de-la-torre.png",orden: "2"},{id: "2",nombre: "Alberto",apellido: "Methol Ferre",tipo: "1",img: "methol-ferre.png",orden: "3"},{id: "3",nombre: "Enrique",apellido: "Dussel",tipo: "2",img: "dussel.png",orden: "4"},{id: "4",nombre: "Anibal",apellido: "Quijano",tipo: "2",img: "quijano.png",orden: "5"},{id: "5",nombre: "Walter",apellido: "Mignolo",tipo: "2",img: "mignolo.png",orden: "6"},{id: "6",nombre: "Catherine",apellido: "Walsh",tipo: "2",img: "walsh.png",orden: "7"},{id: "7",nombre: "Maria",apellido: "Lugones",tipo: "3",img: "lugones.png",orden: "8"},{id: "8",nombre: "Ochy",apellido: "Curriel",tipo: "3",img: "curriel.png",orden: "9"}];
      /* END TEST DATA ---------------------*/

    },

    autorClases (tipo){
      return 'autor-item autor-tipo-' + tipo;
    },

    autorImg (img){
      return 'background-image: url("/static/img/autores/'+ img +'");';
      // return 'background-image: url("static/img/autores/'+ img +'");';
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue